import { useState } from 'react'

const useFocus = () => {
  const [focusMode, setFocusMode] = useState(false)

  const handleFocus = () => {
    setFocusMode(true)
  }

  const handleBlur = () => {
    setFocusMode(false)
  }
  return { focusMode, handleFocus, handleBlur }
}

export default useFocus
